/** @format */

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Provider as ReduxProvider } from 'react-redux';
import { useRoutes } from 'react-router-dom';
// import { SettingsButton } from "./components/settings/settings-button";
// import { SettingsDrawer } from "./components/settings/settings-drawer";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SplashScreen } from './components/splash-screen';
import Toaster from './components/toast/toaster';
import { gtmConfig } from './config';

import { SettingsConsumer, SettingsProvider } from './contexts/settings-context';
import { useAnalytics } from './hooks/use-analytics';
import { useNprogress } from './hooks/use-nprogress';
import { routes } from './routes';
import { store } from './store';
import './styles/animation.css';
import './styles/global.css';
import { createTheme } from './theme';

import 'react-quill/dist/quill.snow.css';

import 'simplebar-react/dist/simplebar.min.css';

import { PageLoading } from './components/page-loading';
import { AuthConsumer, AuthProvider } from './contexts/auth-context';
import './locales/i18n';
import NoticeCenter from './sections/notification';

// Create a client
const queryClient = new QueryClient();

export const App = () => {
  useAnalytics(gtmConfig);
  useNprogress();

  const element = useRoutes(routes);

  return (
    <ReduxProvider store={store}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <AuthConsumer>
              {(auth) => (
                <SettingsProvider>
                  <SettingsConsumer>
                    {(settings) => {
                      // Prevent theme flicker when restoring custom settings from browser storage
                      if (!settings.isInitialized) {
                        // return null;
                      }

                      const theme = createTheme({
                        colorPreset: settings.colorPreset,
                        contrast: settings.contrast,
                        direction: settings.direction,
                        paletteMode: settings.paletteMode,
                        responsiveFontSizes: settings.responsiveFontSizes
                      });

                      // Prevent guards from redirecting
                      const showSlashScreen = !auth.isInitialized;

                      return (
                        <ThemeProvider theme={theme}>
                          {/* <RTL direction={settings.direction}> */}
                          <CssBaseline />
                          {showSlashScreen ? (
                            <SplashScreen />
                          ) : (
                            <>
                              <NoticeCenter />
                              {element}
                              <PageLoading />
                              {/* <SettingsButton onClick={settings.handleDrawerOpen} />
                              <SettingsDrawer
                                canReset={settings.isCustom}
                                onClose={settings.handleDrawerClose}
                                onReset={settings.handleReset}
                                onUpdate={settings.handleUpdate}
                                open={settings.openDrawer}
                                values={{
                                  colorPreset: settings.colorPreset,
                                  contrast: settings.contrast,
                                  direction: settings.direction,
                                  paletteMode: settings.paletteMode,
                                  responsiveFontSizes: settings.responsiveFontSizes,
                                  stretch: settings.stretch,
                                  layout: settings.layout,
                                  navColor: settings.navColor
                                }}
                              /> */}
                            </>
                          )}
                          <Toaster />
                          {/* </RTL> */}
                        </ThemeProvider>
                      );
                    }}
                  </SettingsConsumer>
                </SettingsProvider>
              )}
            </AuthConsumer>
          </AuthProvider>
        </QueryClientProvider>
      </LocalizationProvider>
    </ReduxProvider>
  );
};
